"use client";

export const OversizeFitTshirtSizeChart = () => (
  <div className="w-full max-w-3xl mx-auto">
    <div className="overflow-x-auto border rounded-lg">
      <table className="min-w-full text-sm sm:text-base border-collapse">
        <caption className="text-left font-semibold p-3">
          Oversized T-Shirt — Size Chart (cm)
        </caption>
        <thead>
          <tr className="bg-gray-100">
            <th scope="col" className="px-4 py-2 text-left font-medium">
              Size
            </th>
            <th scope="col" className="px-4 py-2 text-center font-medium">
              Chest (cm)
            </th>
            <th scope="col" className="px-4 py-2 text-center font-medium">
              Front Length (cm)
            </th>
            <th scope="col" className="px-4 py-2 text-center font-medium">
              Sleeve Length (cm)
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              S
            </th>
            <td className="px-4 py-2 text-center">106.7</td>
            <td className="px-4 py-2 text-center">73.7</td>
            <td className="px-4 py-2 text-center">24.8</td>
          </tr>
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              M
            </th>
            <td className="px-4 py-2 text-center">111.8</td>
            <td className="px-4 py-2 text-center">75.6</td>
            <td className="px-4 py-2 text-center">25.4</td>
          </tr>
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              L
            </th>
            <td className="px-4 py-2 text-center">116.8</td>
            <td className="px-4 py-2 text-center">77.5</td>
            <td className="px-4 py-2 text-center">26.0</td>
          </tr>
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              XL
            </th>
            <td className="px-4 py-2 text-center">121.9</td>
            <td className="px-4 py-2 text-center">79.4</td>
            <td className="px-4 py-2 text-center">26.7</td>
          </tr>
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              2XL
            </th>
            <td className="px-4 py-2 text-center">127.0</td>
            <td className="px-4 py-2 text-center">81.3</td>
            <td className="px-4 py-2 text-center">27.3</td>
          </tr>
          <tr>
            <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
              3XL
            </th>
            <td className="px-4 py-2 text-center">132.1</td>
            <td className="px-4 py-2 text-center">83.2</td>
            <td className="px-4 py-2 text-center">27.9</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);
